module.exports = __webpack_public_path__ + "img/Reform-assistance@2x.84b3f4ae.png";